import { countriesInEU } from '@/core/country/countriesInEU';
import { CountryEnum } from '@/core/country/country.enum';

export const countriesWithReceiveEmail = [
  CountryEnum.AU.toString(),
  CountryEnum.CANADA.toString(),
].concat(countriesInEU);
